export default __webpack_public_path__ + "static/media/poster_home.33b19670.webp";